import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { TimeCost } from './components/sections/TimeCost';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { WhatsInside } from './components/sections/WhatsInside';
import { Tools } from './components/sections/Tools';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-cream font-sans antialiased" data-id="element-0" data-mp="3ikh9me1wn113">
      <MetaPixel data-id="element-1" data-mp="3ihuyy5jpw5en" />
      <Hero data-id="element-2" data-mp="3mlj6io8cn0zw" />
      <main data-id="element-3" data-mp="3ml1397n9rmih">
        <TimeCost data-id="element-4" data-mp="3mkrgru1fnxhj" />
        <BeforeAfter data-id="element-5" data-mp="3mjzsz5e2v41t" />
        <PainPoints data-id="element-6" data-mp="3mjg8bgx1m1k3" />
        <WhatsInside data-id="element-7" data-mp="3rc9co3oln7vn" />
        <Tools data-id="element-8" data-mp="3rbzmog3k10py" />
        <Bonuses data-id="element-9" data-mp="3rdatypw7kqlt" />
        <Offer data-id="element-10" data-mp="3rcsuzli5vya7" />
        <Guarantee data-id="element-11" data-mp="3recctgjguhe3" />
        <Testimonials data-id="element-12" data-mp="5ygolyg4xb6" />
        <About data-id="element-13" data-mp="680tswt8a8y" />
        <FAQ data-id="element-14" data-mp="4n53zyrel9i" />
        <FinalCTA data-id="element-15" data-mp="5gbv0xpxarn" />
      </main>
      <Footer data-id="element-16" data-mp="2zl3a7gleoy37" />
      <FloatingCTA data-id="element-17" data-mp="2zld4hgdhhrep" />
      <PurchasePopup data-id="element-18" data-mp="2zm4y4lnitf2c" />
    </div>;
}